import { render, staticRenderFns } from "./advanceSettingsCompenent.vue?vue&type=template&id=3fa68877"
import script from "./advanceSettingsCompenent.vue?vue&type=script&lang=js"
export * from "./advanceSettingsCompenent.vue?vue&type=script&lang=js"
import style0 from "./advanceSettingsCompenent.vue?vue&type=style&index=0&id=3fa68877&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports